"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const classnames_1 = __importDefault(require("classnames"));
const identityLogomark_styles_1 = __importDefault(require("./identityLogomark.styles"));
class IdentityLogomark extends react_1.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, className } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: "1.41421", clipRule: "evenodd", viewBox: "0 0 353 306", "aria-hidden": "true", className: classnames_1.default(classes.root, className || classes.default) }, { children: jsx_runtime_1.jsx("path", { d: "M291.128 305.998h-46.51l-.176-.418v.42H104.174v-.002H61.872l98.959-232.7h31.338l98.959 232.7zm-63.232-39.583l-5.047-11.947-17.152-39.892-29.358-68.809-29.366 68.809-16.822 39.892-5.047 11.947h102.792zm16.546-226.83H104.174V0h140.268v39.585z" }, void 0) }), void 0));
        };
    }
}
IdentityLogomark.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    className: prop_types_1.default.string
};
IdentityLogomark.defaultProps = {
    className: ''
};
exports.default = react_jss_1.default(identityLogomark_styles_1.default)(IdentityLogomark);
//# sourceMappingURL=index.js.map